<template>
    <div class="open">
        <!-- 顶部导航 -->
        <nav-bar ref="navBar" :maxOpacity="0.5" bgColor="#000" v-if="!type" @watchScroll="watchScroll">
            <div class="nav-box">
                <img class="back" :src="backUrl" @click="goBack">
                <div :style="{color:fontColor}">邮政储蓄银行数币钱包开通教程</div>
                <div class="back"></div>
            </div>
        </nav-bar>
        <div :style="`padding-top:calc(10.333vw + ${statusBarHeight}px)`"></div>
        <img class="open-mode" src="../../assets/images/postalNewCustomer/open_mode1.jpg">
        <img class="open-mode second" src="../../assets/images/postalNewCustomer/open_mode2.jpg">
    </div>
</template>

<script>
import navBar from './components/NavBar.vue'
import whiteBack from '../../assets/images/postalNewCustomer/back.png'
import blackBack from '../../assets/images/postalNewCustomer/back_black.png'
export default {
    components: { navBar },
    data() {
        return {
            type: '',
            fontColor: '#000',
            backUrl: blackBack
        }
    },
    computed: {
        statusBarHeight() {
            return this.$store.state.user.statusBarHeight
        },
    },
    created() { },
    mounted() {
        if (this.$route.query.type) this.type = this.$route.query.type
    },
    beforeDestroy() { },
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        watchScroll(scroll) {
            if (scroll <= 10) {
                this.fontColor = '#000'
                this.backUrl = blackBack
            } else {
                this.fontColor = '#fff'
                this.backUrl = whiteBack
            }
        }
    },
}
</script>

<style lang="scss" scoped>
@function pxvw($px) {
    @return ($px / 750) * 100 * 1vw;
}
.nav-box {
    width: 100vw;
    padding: 0 pxvw(30);
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    font-size: pxvw(32);
    height: 10.333vw;
    .back {
        width: pxvw(34);
        height: pxvw(34);
    }
}
.open {
    background: #e7fbf2;
}
.open-mode {
    width: 100vw;
    display: block;
    font-size: 0;
    &.first {
        min-height: pxvw(5177);
    }
    &.second {
        min-height: pxvw((1333));
    }
}
</style>